export { default } from './IntegrationsFilter.vue'
